import { DeeplinkState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: DeeplinkState = {
  message: '',
  url: '',
  sawSplash: false,
  deeplinkedTo: false,
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'DEEPLINK_URL':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
